import $ from 'jquery';
import skUI from '../components/sk-ui';

$(window).on('load', function() {
  const smbParent = $('.menu-outer');
  const topValues = [0];
  let currentScrollTop = 0;
  const mobileWidth = 992;
  const mobileNavHeight = skUI.onScrollBy.mobileNavHeight;
  const desktopNavHeight = 110;

  const smallBusiness = {
    init() {
      if (window.location.hash !== '') {
        smallBusiness.changeSection(window.location.hash.substring(1));
      }
      $(window).scroll(smallBusiness.openShareScroll);
      skUI.onScrollBy.watch(
        smbParent,
        [
          {
            mobile: -mobileNavHeight,
            desktop: -desktopNavHeight,
            breakpoint: mobileWidth
          }
        ],
        function() {
          if (smallBusiness.getWindowWidth() < mobileWidth) {
            smallBusiness.topValuesAdd($('.nav__main__wrapper').height());
            smbParent.addClass('mobile-menu-attach');
          } else {
            smbParent.css('top', `${desktopNavHeight}px`);
            smbParent.addClass('mobile-menu-attach');
          }
        },
        function() {
          if (smallBusiness.getWindowWidth() < mobileWidth) {
            smallBusiness.topValuesPop();
            smbParent.removeClass('mobile-menu-attach');
          } else {
            smbParent.css('top', '');
            smbParent.removeClass('mobile-menu-attach');
          }
        }
      );
      skUI.onScrollBy.watch(
        $('.smb-content-wrapper'),
        -10,
        function(elem) {
          $('.scroll-selected').removeClass('scroll-selected');
          $(`.menu-outer a[href='#${elem.id}']`).addClass('scroll-selected');
        },
        function(elem, index, elemsList) {
          $('.scroll-selected').removeClass('scroll-selected');
          if (index > 0) {
            $(`.menu-outer a[href='#${elemsList[index - 1].id}']`).addClass(
              'scroll-selected'
            );
          }
        }
      );
      if (smallBusiness.getWindowWidth() > 480) {
        skUI.onScrollBy.init(
          $('#footer'),
          -(desktopNavHeight + smbParent.outerHeight()),
          true,
          true,
          function() {
            if (smallBusiness.getWindowWidth() >= mobileWidth) {
              $('.blog-smb').css('position', 'relative');
              smbParent.css('position', 'absolute');
              smbParent.css('top', 'initial');
              smbParent.css('bottom', '0');
              smbParent.css('z-index', '1');
            }
          },
          function() {
            if (smallBusiness.getWindowWidth() >= mobileWidth) {
              $('.blog-smb').css('position', 'static');
              smbParent.css('position', '');
              smbParent.css('top', `${desktopNavHeight}px`);
              smbParent.css('bottom', 'initial');
            }
          }
        );
      }

      $('#mobile-menu-select').on('click', function(e) {
        e.preventDefault();
        if (smbParent.hasClass('mobile-menu-open')) {
          smallBusiness.closeMenu();
        } else {
          currentScrollTop = $(document).scrollTop();
          smallBusiness.openMenu();
        }
      });

      $('.smb-menu-link').on('click', function(e) {
        const smbHash = $(this)
          .attr('href')
          .substring(1);

        if (window.location.hash.substring(1) !== smbHash) {
          smallBusiness.changeSection(smbHash);

          if (smallBusiness.getWindowWidth() < mobileWidth) {
            e.preventDefault();
            const scrollPosition = $(`#${smbHash}`).offset().top - 47;
            window.location.hash = smbHash;
            if (scrollPosition < currentScrollTop) {
              window.scrollTo(0, scrollPosition);
            } else {
              window.scrollTo(0, currentScrollTop);
            }
          }
        } else {
          e.preventDefault();
          smallBusiness.closeMenu();
        }
      });

      $('.menu-background').on('click', function() {
        smallBusiness.closeMenu();
      });
    },
    openShareScroll() {
      $('.blog__share__icons').addClass('active');
      $(window).off('scroll', smallBusiness.openShareScroll);
    },
    openMenu() {
      const windowHeight = $(window).height();
      const navHeight = $('#navigation').height();

      smallBusiness.topValuesAdd($('#navigation').height());
      smbParent.addClass('mobile-menu-open');
      smbParent.css('height', `${windowHeight - navHeight}px`);

      $('body').css('overflow', 'hidden');
      $('.back-to-top.anchor-link').hide();
    },
    closeMenu() {
      smallBusiness.topValuesPop();
      smbParent.removeClass('mobile-menu-open');
      smbParent.css('height', '');

      $('body').css('overflow', 'auto');
      $('.back-to-top.anchor-link').show();
    },
    changeSection(sectionId) {
      $('.smb-menu-link.selected').removeClass('selected');
      $(`.menu-outer a[href='#${sectionId}']`).addClass('selected');

      $('.smb-open').removeClass('smb-open');
      $(`#${sectionId}`).addClass('smb-open');

      $('#mobile-menu-select').text(
        $(`.menu-outer a[href='#${sectionId}']`).text()
      );
      smallBusiness.closeMenu();
    },
    topValuesAdd(value) {
      smbParent.css('top', `${value}px`);
      topValues.push(value);
    },
    topValuesPop() {
      if (smallBusiness.getWindowWidth() >= mobileWidth) {
        return;
      }
      let topPopValue = topValues[0];
      if (topValues.length > 1) {
        topValues.pop();
        topPopValue = topValues[topValues.length - 1];
      }
      smbParent.css('top', `${topPopValue}px`);
    },
    getWindowWidth() {
      return $(window).width();
    }
  };

  smallBusiness.init();
});
